(() => {
  if (window.arroHornetOfferLoaded) return;
  window.arroHornetOfferLoaded = true;

  // Prepare the campaign code only. The shared landing snippet adds both variants.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-arro-hornet-discount]');
    if (!form) return;
    if (form.dataset.discountPrepared === 'true') {
      delete form.dataset.discountPrepared;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;
    const status = form.querySelector('[data-landing-cart-status]');
    const label = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = form.dataset.addingText;
    if (status) status.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
      if (!cartResponse.ok) throw new Error(form.dataset.discountError);
      const cart = await cartResponse.json();
      const codes = (cart.discount_codes || []).map(item => item.code);
      codes.push(form.dataset.arroHornetDiscount);
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({discount: [...new Set(codes)].join(',')})
      });
      if (!response.ok) throw new Error(form.dataset.discountError);
      form.dataset.discountPrepared = 'true';
      button.disabled = false;
      button.innerHTML = label;
      button.removeAttribute('aria-busy');
      form.requestSubmit(button);
    } catch (error) {
      if (status) status.textContent = error.message || form.dataset.discountError;
      button.disabled = false;
      button.innerHTML = label;
      button.removeAttribute('aria-busy');
    }
  }, true);

  const init = (root = document) => {
    root.querySelectorAll('[data-arro-offer]').forEach(offer => {
      if (offer.dataset.choicesBound) return;
      offer.dataset.choicesBound = 'true';
      offer.addEventListener('change', event => {
        const choice = event.target.closest('[data-arro-offer-choice]');
        if (!choice) return;
        offer.querySelectorAll('[data-arro-offer-panel]').forEach(panel => {
          panel.hidden = panel.dataset.arroOfferPanel !== choice.value;
        });
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
